module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-HeavyItalic.ffaf0ed.woff2";